$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

{ UnsplashTracker } = require '@trello/unsplash'
FavIcon = require 'app/scripts/lib/favicon'
BoardBackgroundPrompt = require 'app/scripts/views/board/board-background-prompt'
BoardBackgroundPromptTooltip = require 'app/scripts/views/board-menu/board-background-prompt-tooltip'
Backgrounds = require 'app/scripts/data/backgrounds'

Util = require 'app/scripts/lib/util'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
{ trackUe } = require '@trello/analytics'

module.exports.unmountBoardBackgroundPrompt = ->
  if @boardBackgroundPromptDiv
    ReactDOM.unmountComponentAtNode(@boardBackgroundPromptDiv)
  @boardBackgroundPromptDiv = null
  @boardBackgroundPromptComponent = null

module.exports.unmountBoardBackgroundPromptPopover = ->
  if @boardBackgroundPromptPopoverDiv
    ReactDOM.unmountComponentAtNode(@boardBackgroundPromptPopoverDiv)
  @boardBackgroundPromptPopoverDiv = null
  @boardBackgroundPromptPopoverComponent = null

module.exports.renderBoardBackgroundPrompt = ->
  if @boardBackgroundPromptDiv?
    @unmountBoardBackgroundPrompt()
  @boardBackgroundPromptDiv ?= document.createElement('div')
  @model.viewState.set('initialBackgroundColor', @model.attributes.prefs.background)

  @setTimeout(=>
    me = Auth.me()

    if !featureFlagClient.get('board.background.prompt', false) \
    || @model.get('prefs').backgroundImage? \
    || !me.isLoggedIn() \
    || !me.isNewMember() \
    || me.isDismissed('board-background-prompt') \
    || !@model.isFirstOwnedBoard() \
    || !@model.owned() \
    || @model.memberList.length > 1 \
    || isInspirationBoard(@model.get('id'))
      return

    # I put this seperate to be clear that this needs to be called after all of the
    # other constraints pass, since calling getExperiment has the side effect of
    # actually bucketing users in snowplow. We'd only want to bucket them if all the
    # above constraints are *not* met
    if getExperiment('boardBackgroundPrompt').get('variation') == 'control'
      return

    trackUe('Board Background Prompt', 'View Prompt')
    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'boardBackgroundPromptInlineDialog'

    @boardBackgroundPromptComponent = React.createElement BoardBackgroundPrompt, {
      model: @model
      onBrowse: =>
        @model.viewState.set('boardBackgroundPromptOpenedSidebar', true)
        @sidebarView.pushView 'backgroundPhotos', component: 'photos'
        @unmountBoardBackgroundPrompt()
      onDismiss: =>
        @model.viewState.set('showBoardBackgroundPromptPopover', true)
        @unmountBoardBackgroundPrompt()
    }
    @$('.board-canvas').append(@boardBackgroundPromptDiv)
    ReactDOM.render(@boardBackgroundPromptComponent, @boardBackgroundPromptDiv)
  , 2 * 1000)

module.exports.renderBoardBackgroundPromptPopover = ->
  if !@model.viewState.get('showBoardBackgroundPromptPopover') \
  || @model.viewState.get('showSidebar')
    @unmountBoardBackgroundPromptPopover()
    return

  @boardBackgroundPromptPopoverComponent = React.createElement(
    BoardBackgroundPromptTooltip,
    {
      onDismiss: =>
        @model.viewState.set('showBoardBackgroundPromptPopover', false)
        @unmountBoardBackgroundPromptPopover()
    }
  )
  @boardBackgroundPromptPopoverDiv = document.createElement('div')
  $(@boardBackgroundPromptPopoverDiv).insertAfter('.js-show-sidebar')
  ReactDOM.render(@boardBackgroundPromptPopoverComponent, @boardBackgroundPromptPopoverDiv)

module.exports.getAllBackgroundClasses = ->
  [
    'body-custom-board-background'
    'body-custom-board-background-tiled'
    'body-light-board-background'
    'body-dark-board-background'
    'body-ambiguous-board-background'
    'body-default-header'
  ].join(" ")

module.exports.defaultBoardBackground = ->
  @clearBoardBackground()
  $('#trello-root').addClass('body-default-header')
  return

module.exports.clearBoardBackground = ->
  prefs = @model.get('prefs')
  allBackgroundClasses = @getAllBackgroundClasses()

  $('#trello-root')
  .removeClass(allBackgroundClasses)
  .css
    'background-image': ''
    'background-color': ''

  return

module.exports.renderBoardBackground = (waitForImage = false) ->
  @clearBoardBackground()

  prefs = @model.get('prefs')
  $body = $('#trello-root')

  if prefs.backgroundColor?
    hexcolor = @model.getClientBackgroundColor(prefs.background)

    $body.css
      'background-color': hexcolor

    FavIcon.setBackground({ color: hexcolor })

  else
    if Backgrounds.hasOwnProperty(prefs.background)
      # Special handling for our default backgrounds, to avoid using the
      # really huge versions
      url = Util.smallestPreviewBiggerThan(
        prefs.backgroundImageScaled,
        640,
        480
      )?.url ? prefs.backgroundImage
    else
      url = prefs.backgroundImage

    if prefs.backgroundTile
      smallUrl = url
    else
      smallUrl =
        Util.smallestPreviewBiggerThan(
          prefs.backgroundImageScaled
          64
          64
        )?.url ? prefs.backgroundImage


    changeBackgroundImage = =>
      $body.addClass('body-custom-board-background')

      if prefs.backgroundTile
        $body.addClass('body-custom-board-background-tiled')

      brightness = prefs.backgroundBrightness

      if prefs.backgroundTopColor
        topBrightness = Util.calculateBrightness(prefs.backgroundTopColor)

        if brightness != topBrightness
          $body.addClass('body-ambiguous-board-background')

      switch brightness
        when 'light'
          $body.addClass('body-light-board-background')
        when 'dark'
          $body.addClass('body-dark-board-background')


      $body
      .css
        'background-image': "url(\"#{url}\")"

      UnsplashTracker.trackOncePerInterval url

      FavIcon.setBackground({ url: smallUrl, tiled: prefs.backgroundTile })

    if waitForImage
      Util.waitForImageLoad url
        .then changeBackgroundImage
    else
      changeBackgroundImage()

module.exports.renderBoardHeaderSubscribed = ->
  isSubscribed = @model.get('subscribed')
  @$('.js-board-header-subscribed').toggleClass('hide', !isSubscribed)
  @
